<template>
  <div class="radio-container">
    <div
      v-for="option in options"
      :key="option.key || option.value"
      class="radio-wrapper"
      :class="spacing"
    >
      <input
        :id="option.id || option.value"
        type="radio"
        :name="name"
        :value="option.value"
        :aria-describedby="option.ariaDescribedBy || 'radio'+id"
        :checked="inputValue === option.value"
        :class="{
          'is-invalid-input':hasError
        }"
        :disabled="option.disabled"
        @click="onClick(option)"
        @blur="handleChange"
      >
      <label
        :class="{ disabled: option.disabled }"
        :for="option.id || option.value"
        @click.prevent="onClick(option)"
      >
        <template v-if="option.labelType?.toLowerCase() === 'html'">
          <component
            :is="option.label"
            v-if="option.label"
          />
        </template>
        <template v-else>{{ option.label }}</template>
      </label>
      <component
        :is="option.additionalText"
        v-if="option.additionalText"
      />
      <slot :id="option.id" />
    </div>
  </div>
</template>
<script>
import generateRandomId from '../../utils/randomNumber';

export default {
  name: 'RadioBasic',
  components: {
  },
  props: {
    name: {
      type: String,
      default: 'radio',
    },
    options: {
      type: Array,
      default: () => [],
    },
    spacing: {
      type: String,
      default: 'margin-bottom-xxs',
    },
    modelValue: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      id: generateRandomId(),
      inputValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newModelValue) {
      if (this.inputValue !== newModelValue) {
        this.inputValue = newModelValue;
        this.$emit('update:modelValue', this.inputValue);
      }
    },
  },
  methods: {
    onClick(option) {
      if (this.inputValue !== option.value) {
        this.inputValue = option.value;
        this.$emit('update:modelValue', this.inputValue);
      }
    },
    handleChange(option) {
      if (option.value === undefined && !this.inputValue) {
        this.$emit('update:modelValue', '');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/csg/src/scss/forms/forms.scss";
@include csg-forms;

input:disabled,
label.disabled {
  pointer-events: none;
}
</style>
